import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSuppliersList } from "./suppliersThunk";
import SuppliersList from "./components/SuppliersList";

const Suppliers = () => {
  const dispatch = useDispatch();
  const { suppliersList } = useSelector((state) => state.suppliers);

  useEffect(() => {
    dispatch(fetchSuppliersList());
  }, [dispatch]);

  return <SuppliersList suppliersList={suppliersList} />;
};

export default Suppliers;
